/**
 * WordPress dependencies
 */

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { default as InspectorInterface } from '../../interface/Inspector/index.js';
import './inspector/tabs';

const Inspector = ( props ) => {
	return <InspectorInterface hookPrefix="service" { ...props } />;
};

export default Inspector;
